
const de = {
  cookieFirst: {
    btnAccept: "AKZEPTIEREN",
    btnDeny: "NICHT ZUSTIMMEN",
    bodyText: "Wir verwenden KEINE Cookies auf unserer Website, um Kunden zu verfolgen. Es wird nur ein Cookie für diese Cookie-Einstellung geben. Sollten Sie dennoch ein Cookie von einem Drittanbieter finden, schreiben Sie uns bitte eine Nachricht. Sie können diese Cookies dann sicher löschen. Indem Sie auf “Akzeptieren” klicken, erklären Sie sich mit der Verwendung dieses Cookies einverstanden."
  },
  cookieTracking: {
    btnAccept: "Akzeptieren",
    btnDecline: "Nicht zustimmen",
    policyWording: "Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies werden verwendet, um Ihr Website-Erlebnis zu verbessern und Ihnen persönlichere Dienste anzubieten, sowohl auf dieser Website als auch über andere Medien. Weitere Informationen über die von uns verwendeten Cookies finden Sie in unserer Datenschutzrichtlinie.",
    cookieDisclaimer: "Wir werden Ihre Daten nicht verfolgen, wenn Sie unsere Website besuchen. Aber um Ihre Präferenzen zu berücksichtigen, müssen wir nur ein winziges Cookie verwenden, damit Sie nicht noch einmal gefragt werden, ob Sie diese Wahl treffen möchten."
  },

  homepage: {
    headerTitle1st:  "Prognostizieren Sie Ihren",
    headerTitle2st: "Markterfolg",
    headerDescriptionFirst: ["MARKSIM", "bietet", "do-it-yourself, easy-to-use, high-end","Marktforschung. Erhalten Sie die Einblicke, die Sie benötigen, innerhalb von Minuten statt Tagen."],
    headerDescriptionSecond: ["Durch die Kombination von Clusteranalyse, Marktkartierung und Do-it-yourself-Conjoint-Analyse bieten wir eine neue Methodik zur Markterkundung. Scrollen Sie nach unten, um mehr zu erfahren oder", "kontaktiere uns."],
    bodyHeader: ["Wie", "funktioniert es?"], 
    bodyHeaderContent: [
      {
        ID: 1,
        NAME: "Sea",
        TITLE: "Marktanalyse",
        TEXT: "Marksim schließt die Lücke zwischen traditioneller Marktforschung und Predictive Analytics.",
      },
      {
        ID: 2,
        NAME: "Running",
        TITLE: "Market Analyses",
        TEXT: "Visualisieren Sie Ihre Marktposition, identifizieren Sie Ihre tatsächlichen Konkurrenten und lernen Sie, wie Sie sie schlagen können!",
      },
      {
        ID: 3,
        NAME: "Smiling",
        TITLE: "Käufermotive",
        TEXT: "Erfahren Sie, warum Kunden Ihre Produkte kaufen und lassen Sie StatShop ein optimales Produkt für Sie finden.",
      },
      {  
        ID: 4,
        NAME: "Cake",
        TITLE: "Marktanteilsvorhersage",
        TEXT: "Machen Sie einfach belastbare Vorhersagen über Ihre zukünftigen Marktanteile.",
      },
      {
        ID: 5,
        NAME: "Arrow",
        TITLE: "Marksim Optimierer",
        TEXT: "Schau nicht zurück! Schauen Sie voraus und entwickeln Sie Ihre Produkte und Dienstleistungen für die Zukunft weiter",
      },
    ],
    bodyFooterContent: [ "Do-it-yourself", "gemeinsame","&","bedarfsgerechte", "Marktsegmentierung."],
    bodyFooterChoosePlan: ["Wähle dein", "Plan"]
  },

  dropdown: {
    overview: "Überblick",
    contact: "Kontakt",
    imprint: "Impressum"
  },

  footer: {
    contactHeader: ["Kennen Sie Ihre","Marktanteile von morgen."],
    contactBody: "Kontaktieren sie uns:",

    FOOTER_COMPANIES: [
      "Gefördert durch Österreichische Forschungsförderungs GmbH" ,
      "Gefördert durch Wirtschaftsagentur Wien 2018" ,
      "Gefördert durch go-international 2019" ,
    ],

    contact: "Kontakt",
    imprint: "Impressum",
    GDPR: "DSGVO"
  },

  imprint: {
    header: "Rechtlicher Hinweis",

    article: [
      {
        header: "Urheberrecht",
        content1: "Urheberrecht Der gesamte Inhalt dieser Website, einschließlich, aber nicht beschränkt auf Texte, Fotos, Grafiken, Logos oder Schaltflächensymbole und den damit verbundenen Computercode, sowie die Zusammenstellung (d.h. die Sammlung, Anordnung und Zusammenfügung) des gesamten Inhalts dieser Website ist das ausschließliche Eigentum von MARKSIM SERVICES GMBH und ist durch das Urheberrecht geschützt. Jegliche Vervielfältigung, Änderung, Verteilung, Übertragung, Wiederveröffentlichung, Anzeige oder Aufführung des Inhalts dieser Website ist ohne vorherige schriftliche Genehmigung von MARKSIM SERVICES GMBH strengstens untersagt."
      }
      ,
      {
        header: "Markenzeichen",
        content1: "MARKSIM ist ein eingetragenes EU-Warenzeichen von MARKSIM SERVICES GMBH und darf ohne ausdrückliche schriftliche Genehmigung von MARKSIM SERVICES GMBH nicht in Verbindung mit einem Produkt oder einer Dienstleistung verwendet werden.",
        content2: "Links Diese Website kann Links zu anderen Websites enthalten, die nicht Eigentum von MARKSIM SERVICES GMBH sind oder von ihr betrieben werden \(\"verlinkte Websites\"\). Die verlinkten Seiten dienen lediglich Ihrer Bequemlichkeit, und Sie greifen auf eigenes Risiko auf sie zu. MARKSIM SERVICES GMBH ist nicht verantwortlich für den Inhalt der verlinkten Seiten, unabhängig davon, ob MARKSIM SERVICES GMBH mit den Sponsoren der Seiten verbunden ist oder nicht. MARKSIM SERVICES GMBH befürwortet in keiner Weise die verlinkten Seiten. MARKSIM SERVICES GMBH begrüßt Links zu dieser Website. Sie können einen Hypertext-Link zu dieser Website einrichten, vorausgesetzt, dass der Link keine Unterstützung oder Befürwortung Ihrer Website durch MARKSIM SERVICES GMBH angibt oder impliziert. Sie dürfen ohne vorherige schriftliche Genehmigung von MARKSIM SERVICES GMBH auf Ihrer Site keine Materialien verwenden, die auf einer MARKSIM SERVICES GMBH-Site erscheinen, einschließlich, aber nicht beschränkt auf Logos oder Zeichen. Es ist Ihnen nicht gestattet, den Inhalt oder andere Materialien der Website von MARKSIM SERVICES GMBH in Frames oder auf andere Weise in eine andere Website einzubinden."
      }
      ,
      {
        header: "Nutzung der Website",
        content1: "Diese Website oder ein Teil davon darf nicht reproduziert, vervielfältigt, kopiert, verkauft, weiterverkauft oder anderweitig für einen Zweck genutzt werden, der nicht ausdrücklich von MARKSIM SERVICES GMBH in doppelter schriftlicher Form genehmigt wurde. MARKSIM SERVICES GMBH behält sich das Recht vor, nach eigenem Ermessen den Service zu verweigern, Konten zu kündigen und/oder Bestellungen zu stornieren, insbesondere, wenn MARKSIM SERVICES GMBH der Meinung ist, dass das Verhalten des Kunden gegen geltendes Recht verstößt oder den Interessen von MARKSIM SERVICES GMBH oder seinen Tochtergesellschaften schadet.",
      }
      ,
      {
        header: "Haftungsausschluss",
        content1: "Diese Seite und die Materialien auf dieser Seite werden von MARKSIM SERVICES GMBH auf einer \"As is\" Basis zur Verfügung gestellt. MARKSIM SERVICES GMBH gibt keinerlei Zusicherungen oder Garantien, weder ausdrücklich noch stillschweigend, in Bezug auf den Betrieb der Website oder die Informationen, Inhalte, Materialien oder Produkte, die auf dieser Website enthalten sind. MARKSIM SERVICES GMBH lehnt, soweit gesetzlich zulässig, alle ausdrücklichen oder stillschweigenden Garantien ab, einschließlich, aber nicht beschränkt auf, stillschweigende Garantien der Marktgängigkeit für einen bestimmten Zweck. Weder MARKSIM SERVICES GMBH noch eine seiner Tochtergesellschaften oder verbundenen Unternehmen noch irgendeine Person, die an der Erstellung, Produktion und Verteilung dieser Website beteiligt ist, garantiert, dass die in den Materialien enthaltenen Funktionen ununterbrochen oder fehlerfrei sind, dass Fehler behoben werden oder dass MARKSIM SERVICES GMBH oder der Server, der sie zur Verfügung stellt, frei von Viren oder anderen schädlichen Komponenten sind. Das Material, das Sie auf dieser Website lesen, wird ausschließlich zu Informations- und Werbezwecken bereitgestellt. MARKSIM SERVICES GMBH gibt keine Garantien oder Zusicherungen in Bezug auf die Nutzung oder die Ergebnisse der Nutzung der Materialien auf dieser Website in Bezug auf die Richtigkeit, Genauigkeit, Zuverlässigkeit oder andere. Sie erklären sich ausdrücklich damit einverstanden, dass die Nutzung dieser Website auf Ihr eigenes Risiko erfolgt. Sie (und nicht MARKSIM SERVICES GMBH) übernehmen die gesamten Kosten für alle notwendigen Wartungsarbeiten, Reparaturen oder Korrekturen. Sie erklären sich ausdrücklich damit einverstanden, dass weder MARKSIM SERVICES GMBH, noch seine angeschlossenen oder verbundenen Unternehmen, noch einer ihrer jeweiligen Mitarbeiter oder Vertreter, noch irgendeine Person oder Einrichtung, die an der Erstellung, Produktion und Verteilung dieser Website beteiligt ist, verantwortlich oder haftbar ist für Verluste, Schäden (ob direkt, indirekt, beiläufig, tatsächlich, als Folge, mit Strafcharakter oder anderweitig), Verletzungen, Ansprüche, Haftungen oder andere Gründe jeglicher Art oder Beschaffenheit, die auf der Nutzung dieser Website oder einer anderen MARKSIM SERVICES GMBH Website beruhen oder daraus resultieren. Sie erkennen ausdrücklich an und stimmen zu, dass MARKSIM SERVICES GMBH nicht haftbar oder verantwortlich ist für verleumderisches, beleidigendes oder illegales Verhalten anderer Abonnenten oder Dritter.",
      }
      ,
      {
        header: "Anwendbares Recht und ausschließliche Zuständigkeit",
        content1: "Diese Website wird von MARKSIM SERVICES GMBH von seinem Hauptsitz in Wien, Österreich (Europa) aus erstellt, kontrolliert und betrieben. MARKSIM SERVICES GMBH gibt keine Zusicherung, dass die Materialien auf dieser Website für die Nutzung an anderen Orten geeignet oder verfügbar sind. Diejenigen, die auf diese Website von anderen Orten aus zugreifen, tun dies auf eigene Initiative und sind für die Einhaltung der lokalen Gesetze verantwortlich, sofern und soweit diese anwendbar sind. Bedingungen und Konditionen von MARKSIM® SaaS",
      }
      ,
      {
        header: "1. Umfang der Dienstleistung bzw. Werkverträge",
        content1: "Das Online-Tool MARKSIM® wird dem Geschäftspartner und/oder (End-) Nutzer von MARKSIM SERVICES GMBH als SaaS (Statistics as a Service) Lösung für die Projektarbeit zur Verfügung gestellt. Sollte die MARKSIM Services GmbH ein Werk schulden, so ist der Auftraggeber zur umfassenden Mitwirkung verpflichtet. Verzögerungen aus diesem Titel können nicht der MARKSIM SERVICES GmbH angelastet werden. Zudem verzichten beide Parteien auf das Instrument der Ersatzvornahmen. Fachliche Fragen sind vom Auftraggeber binnen 2 Werktagen vollständig und umfassend zu beantworten."
      }
      ,
      {
        header: "2. Bestellung, Zahlungs- und Stornobedingungen",
        content1: "Bestellung, Zahlungsbedingungen und Stornierung: Bestellungen bei MARKSIM SERVICES GMBH bedürfen der Schriftform. Sofern nicht anders vereinbart, ist MARKSIM SERVICES GMBH berechtigt, die erste Teilrechnung in Höhe von 50% der Auftragssumme sofort nach Auftragserteilung zu stellen. Die zweite Teilrechnung (50% der Auftragssumme) wird nach dem Einspielen und der Online-Stellung der Daten (Freischaltung) fällig. Bei Zahlungsverzug werden 9 % über dem Basiszinssatz als Verzugszinsen vereinbart. MARKSIM SERVICES GMBH ist in diesem Fall berechtigt, den Zugang zum jeweiligen Simulationsportal sofort zu sperren und vom Vertrag zurückzutreten. Bei Zahlungsverzug (über 2 Monate) gehen alle Studien und zugehörigen Daten in das Eigentum von MARKSIM über. Sofern nichts anderes vereinbart ist (z.B. Mindestkontaktzeit), können die Leistungen jederzeit vom Nutzer gekündigt werden. MARKSIM erstattet alle vorausbezahlten Zeiträume, gerechnet ab dem Monat nach der Kündigung. Wenn z.B. die Kündigung bis zum 31. Oktober eingeht, werden alle zukünftigen Zeiträume ab Dezember erstattet. Eine Stornierungsmitteilung muss auf demselben Weg versandt werden, auf dem die Bestellung eingegangen ist. Wenn z.B. eine Bestellung per E-Mail eingegangen ist, wird die Stornierung auch per E-Mail versandt. Wenn eine Bestellung per Online-Rechnung aufgegeben wurde, muss die Stornierung auf demselben Weg erfolgen."
      }
      ,
      {
        header: "3. Wartung, Datensicherheit und Service Level",
        content1: "In der Regel wird MARKSIM SERVICES GMBH den Zugang zum Simulationsportal 24 Stunden am Tag ermöglichen. Die Ankündigung von routinemäßigen Wartungsarbeiten wird auf der Homepage marksim.net veröffentlicht. Wartungsarbeiten können täglich zwischen 18.00 und 08.00 Uhr sowie ganztägig an Samstagen, Sonn- und Feiertagen durchgeführt werden. Dringende und notwendige Wartungsarbeiten können auch tagsüber durchgeführt werden. MARKSIM® arbeitet in zertifizierten Rechenzentren mit 24/7-Support. Das Service-Fenster kann am Sonntag zwischen 20:00 Uhr und Montag 6:00 Uhr MEZ sein. MARKSIM SERVICES GMBH ist bestrebt, für seine Geschäftspartner und Kunden einen Service Level von 99,9% zu gewährleisten, kann aber keine Garantie geben."
      }
    ]
  },

  
  contact: {
    contactHeader: "Kontakt",
    contactContent: "Hier werden Kontaktinformation stehen"
  },

  Plans: 
  {
      "plan_description": [
          {"id": "1","description": "Trial Period", "info": "undefined"},
          {"id": "2","description" : "Minimum Term", "info" : "undefined"},
          {"id": "3","description": "Free Period", "info":"undefined"},
          {"id": "4","description":"Biling Period", "info":"undefined"},
          {"id": "5","description":"Import CBC", "info":"Import CBC"},
          {"id": "6","description":"Design CBC", "info":"Design CBC"},
          {"id": "7","description":"HBL", "info":"HBL"},
          {"id": "8","description":"One free Project", "info":"One free Project"},
          {"id": "9","description":"User Licenses", "info":"User Licenses"},
          {"id": "10","description":"Initial setup", "info":"undefined"},
          {"id": "11","description":"Support", "info":"Support"},
          {"id": "12","description":"Create Design Conjoint Analysis (CBC)","info": "Create Design Conjoint Analysis (CBC)"},
          {"id": "13","description":"Use our Limsurvey Conjoint-Modul", "info":"Use our Limsurvey Conjoint-Modul"},
          {"id": "14","description":"Use our Limsurvey questionnaire platform", "info":"undefined"}
      ],

      "plan": [
          {
                  "id": "1",
                  "name": "Basic",
                  "description": "Market Mapping",
                  "provides": [
                      "2 Tage",
                      "3 months",
                      "1 month",
                      "3 months",
                      "true",
                      "false",
                      "false",
                      "true",
                      "true",
                      "true",
                      "12 months",
                      "true",
                      "true",
                    "true"
                  ],
                  "cost_ones": "€ 690",
                  "cost_monthly": "€ 49",
                  "on_sale": "52 %"
          },
          {
              "id":"2",
              "name": "Professional",
              "description": "Market Mapping & Standard Conjoint",
              "provides": [
                  "2 days",
                  "3 months",
                  "1 month",
                  "3 months",
                  "true",
                  "true",
                  "false",
                  "true",
                  "true",
                  "true",
                  "12 months",
                  "true",
                  "true",
                  "true"
              ],
              "cost_ones": "€ 999",
              "cost_monthly": "€ 99",
              "on_sale": "52 %"
          },
          {
              "id":"3",
              "name": "Corporate",
              "description": "Market Mapping & Proffesional HBL-Conjoint",
              "provides": [
                  "2 days",
                  "3 months",
                  "1 month",
                  "3 months",
                  "true",
                  "true",
                  "true",
                  "true",
                  "true",
                  "true",
                  "12 months",
                  "true",
                  "true",
                  "true"
              ],
              "cost_ones": "€ 2490",
              "cost_monthly": "€ 249",
              "on_sale": "52 %"
          } 
      ],

      "plan_information_text": [
        "START TRIAL",
        "Setup fee" ,
        "Monat",
        "On Sale - save",
        "View features",
      ]
  }  
};

export default de;
